export class OEPanelGammaCustomiseModel {
  public permissions: {
    submit: boolean;
  } = {
    submit: true,
  };

  public editData: {
    isEditEnabled: boolean;
  } = {
    isEditEnabled: true,
  };
}
